<template>
    <div>
        <block v-if="loading"></block>
        <v-card flat>
            <v-card-text style="z-index: 1">
                <template v-if="type === 'medicalclinic'">
                    <user-profile-lab :patient="data" :patientinfo="data" :useData="useData"></user-profile-lab>
                </template>
                <template v-else>
                    <user-profile :patientinfo="patientinfo" :data="data" :useData="useData" />
                </template>

                <v-row style="margin-top: 1rem">
                    <v-col cols="12" class="box medical-history-box" style="margin-top: 1rem">
                        <v-form v-model="valid" class="position-relative">
                            <div>
                                <v-row class="ml-2 mr-2" style="margin-top: 0.3rem">
                                    <v-col cols="12" class="tabsNh">
                                        <v-col cols="12" md="12" style="display: flex; justify-content: space-between">
                                            <div class="medical-history-actions-left">
                                                <v-checkbox
                                                    v-if="isAutosaveEnabled"
                                                    v-model="componentAutosaveEnabled"
                                                    hide-details
                                                    dense
                                                    label="Autoguardado"
                                                    class="autosave-toggle mt-0 pt-0"
                                                ></v-checkbox>
                                                <span
                                                    v-if="isAutosaveActive && autosaveStatusLabel"
                                                    class="autosave-status ml-3"
                                                    :class="`autosave-status--${autosaveStatus}`"
                                                >
                                                    {{ autosaveStatusLabel }}
                                                </span>
                                            </div>
                                            <div>
                                                <v-btn v-if="$store.getters['rolesUser/getCustomRole'](107)" small class="btn-save mr-1" @click.prevent="showBillPatient = true">
                                                    <v-icon class="mr-3">mdi-account-details</v-icon> Facturar paciente
                                                </v-btn>
                                            </div>
                                            <!--  <v-btn @click.prevent="">
                                                <v-icon>
                                                    mdi-printer
                                                </v-icon>
                                            
                                                </v-btn> -->
                                            <div>
                                                <v-btn small class="btn mr-1" @click="printMedicalHistory()">
                                                    <v-icon> mdi-printer </v-icon>
                                                </v-btn>
                                                <v-btn small class="btnblue mr-1" @click="showMedicalData = !showMedicalData" v-if="$store.getters['rolesUser/getCustomRole'](138)">
                                                    <v-icon> mdi-magnify </v-icon>
                                                </v-btn>
                                                <v-btn small class="btnclean mr-1" @click.prevent.stop="resetData()">
                                                    <v-icon> mdi-broom </v-icon>
                                                </v-btn>
                                                <v-btn small v-if="selectedvalues && $store.getters['rolesUser/getCustomRole'](172)
                                                    " class="btn-save" @click.prevent.stop="saveMedicalHistory()">
                                                    <v-icon> mdi-content-save </v-icon>
                                                </v-btn>
                                                <v-btn small v-if="medicalhistory.ID_MH &&
                                                    $store.getters['rolesUser/getCustomRole'](172)
                                                    " class="btn-save" @click.prevent.stop="updateMedicalHistory()">
                                                    <v-icon> mdi-content-save </v-icon>
                                                </v-btn>
                                            </div>
                                        </v-col>
                                    </v-col>

                                    <v-col cols="12" md="2" sm="12" style="margin-top: 1rem">
                                        <date-picker label="Fecha" @dateSelected="(param) => {
                                                date = param;
                                                checkhistoryDatetoday(param);
                                            }
                                            " v-model="date"></date-picker>
                                    </v-col>
                                    <v-col cols="6" md="2" style="margin-top: 1rem">
                                        <v-text-field label="Peso" dense outlined v-model="weight" @change="changeWeight"></v-text-field>
                                    </v-col>
                                    <v-col cols="6" md="2" style="margin-top: 1rem">
                                        <v-select outlined dense attach @change="switchWeightUnit" v-model="weightunit" :items="['Kg', 'Lb']" label="Unidad de peso"></v-select>
                                    </v-col>
                                    <v-col cols="6" md="2" style="margin-top: 1rem">
                                        <v-text-field label="Talla" dense outlined v-model="medicalhistory.height"></v-text-field>
                                    </v-col>
                                    <v-col cols="6" md="2" style="margin-top: 1rem">
                                        <v-text-field label="Pulso" dense outlined v-model="medicalhistory.pulse"></v-text-field>
                                    </v-col>
                                    <v-col cols="6" md="2" style="margin-top: 1rem">
                                        <v-text-field label="Temperatura" dense outlined v-model="medicalhistory.temp"></v-text-field>
                                    </v-col>
                                    <v-col cols="6" md="2" style="margin-top: 1rem">
                                        <v-text-field label="Frecuencia cardiaca" dense outlined v-model="medicalhistory.heartRate"></v-text-field>
                                    </v-col>
                                    <v-col cols="6" md="2" style="margin-top: 1rem">
                                        <v-text-field label="Frecuencia respiratoria" dense outlined v-model="medicalhistory.breathRate"></v-text-field>
                                    </v-col>

                                    <v-col cols="6" md="2" style="margin-top: 1rem;">
                                        <v-checkbox label="Veterinario externo" dense outlined v-model="medicalhistory.vetExt" @change="handlerVetExt"></v-checkbox>
                                    </v-col>
                                    <v-col cols="6" md="2" style="margin-top: 1rem">
                                        <v-text-field v-if="vetExt" label="Nombre del veterinario" dense outlined v-model="medicalhistory.nameExt"></v-text-field>
                                    </v-col>

                                    <v-col cols="12" md="2"
                                        style="display: flex; justify-content: flex-end; margin-top: 1rem">
                                        <v-btn @click="showComments = !showComments"
                                            :class="medicalhistory.Comment ? 'btnclean' : 'btnblack'">
                                            Comentarios
                                        </v-btn>
                                    </v-col>
                                </v-row>

                                <br />
                                <v-row class="ml-2 mr-2" style="margin-top: 0.3rem">
                                    <!-- <v-col cols="12" md="12" sm="12" >
                                            <h2>DIAGNÓSTICOS</h2>
                            
                                </v-col> -->

                                    <v-col cols="12" md="6">
                                        <label class="mb-3 d-inline-block label-forms">Resumen de historia y examen físico
                                        </label>
                                        <span class="ql-editor150">
                                            <quill-editor v-model="medicalhistory.PhysicalHistorySummary"
                                                :options="quillOptions" @change="onEditorChange($event)"></quill-editor>
                                        </span>
                                        <br />
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <label class="mb-3 d-inline-block label-forms">Diagnóstico Presuntivo
                                        </label>
                                        <span class="ql-editor150">
                                            <quill-editor v-model="medicalhistory.PresumptiveDiagnosis"
                                                :options="quillOptions" @change="onEditorChange($event)"></quill-editor>
                                        </span>
                                        <br />
                                    </v-col>

                                    <v-col cols="12" md="6">
                                        <label class="mb-3 d-inline-block label-forms">Diagnóstico Definitivo
                                        </label>
                                        <span class="ql-editor150">
                                            <quill-editor v-model="medicalhistory.FinalDiagnosis" :options="quillOptions"
                                                @change="onEditorChange($event)"></quill-editor>
                                        </span>
                                        <br />
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <label @click="showTreat = !showTreat"
                                            class="mb-3 d-inline-block label-forms">Tratamiento
                                        </label>
                                        <span class="ql-editor150">
                                            <quill-editor v-model="medicalhistory.Treatment" :options="quillOptions"
                                                @change="onEditorChange($event)"></quill-editor>
                                        </span>
                                        <br />
                                    </v-col>
                                </v-row>

                                <v-row style="margin-bottom: 1.2rem; margin-top: 0.6rem"> </v-row>
                            </div>
                        </v-form>
                    </v-col>
                </v-row>
                <br />
                <hr />
                <br />

                <v-dialog v-model="dialog" max-width="350">
                    <v-card>
                        <v-card-title class="text-h6"> ¿Desea eliminar el registro? </v-card-title>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red darken-1" text @click="dialog = false"> No </v-btn>
                            <v-btn color="green darken-1" text @click="
                                deleteMedicalHistory(temp);
                            dialog = false;
                            temp = null;
                            ">
                                Si
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <alerts v-if="alert.show" v-on:close_alert="closeAlert" v-on:accept_alert="acceptAlert" :properties="alert">
                </alerts>
            </v-card-text>
            <v-dialog v-model="showMedicalData" :width="'90%'" scrollable>
                <v-card flat class="pa-4">
                    <v-card-text>
                        <div style="margin-top: 0.3rem; margin-bottom: 0.3rem; display: flex; justify-content: flex-end;">
                            <v-btn small class="btndelete" @click.prevent="showMedicalData = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </div>
                        <GeneralFilter 
                            class="background border-box" 
                            entity="cliente"
                            :filterEndpoint="$API.veterinarymedicalhistory.filterloadMedicalHistory" :search="searchHistory"
                            @emptyFilter="loadHistoryMedical" @filtered="filterHandler"
                        >
                            <DxDataGrid 
                                class="isScrolledByGeneralFilter" 
                                :show-borders="true" 
                                :data-source="medicalhistorys"
                                key-expr="" 
                                @exporting="onExporting" 
                                :column-auto-width="true"
                                style="width: fit-content;"
                            >
                                <DxExport :enabled="true" />
                                <DxColumn :width="80" cell-template="show-template" caption=""></DxColumn>
                                <!--  <DxColumn data-field="ID_MH" caption="Id"></DxColumn> -->
                                <DxColumn data-field="MedicalHistoryDate" caption="Fecha" :min-width="100"></DxColumn>
                                <DxColumn data-field="Weight" caption="Peso"  :min-width="100"></DxColumn>
                                <DxColumn data-field="FullName" caption="Atendido por" :min-width="200"></DxColumn>
                                <DxColumn data-field="PhysicalHistorySummaryTable" caption="Resumen de historia y examen físico" :min-width="300" cssClass="left-align"></DxColumn>
                                <DxColumn data-field="PresumptiveDiagnosisTable" caption="Diagnóstico Presuntivo" :min-width="300" cssClass="left-align"></DxColumn>
                                <DxColumn data-field="FinalDiagnosisTable" caption="Diagnóstico Definitivo" :min-width="300" cssClass="left-align"></DxColumn>
                                <DxColumn data-field="TreatmentTable" caption="Tratamiento" :min-width="300" cssClass="left-align"></DxColumn>
                                <DxColumn :width="80" cell-template="delete-template" caption="" v-if="$store.getters['rolesUser/getCustomRole'](139)">
                                </DxColumn>
                                <template #show-template="{ data }">
                                    <div>
                                        <a href="#" @click.prevent.stop="
                                            showMedicalHistory(data.data);
                                        selectedvalues = false;
                                        showMedicalData = false;
                                        ">
                                            <v-icon color="primary">mdi-eye</v-icon>
                                        </a>
                                    </div>
                                </template>
                                <template #delete-template="{ data }">
                                    <div>
                                        <a href="" class="mx-2" @click.prevent.stop="
                                            confirmdelete(data.data);
                                        showMedicalData = false;
                                        ">
                                            <v-icon color="error">mdi-delete</v-icon>
                                        </a>
                                    </div>
                                </template>
                            </DxDataGrid>
                        </GeneralFilter>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-card>

        <!-- Dialog bill patient -->
    <VeterinaryBillingPanel v-model="showBillPatient" :customer-id="data && data.ID_Customer ? data.ID_Customer : (customer && customer.ID_Customer ? customer.ID_Customer : null)" />
        <!-- Dialog bill patient -->

        <v-dialog v-model="showComments" max-width="60%">
            <v-card class="pa-4">
                <div style="
            margin-top: 0.3rem;
            margin-bottom: 0.3rem;
            display: flex;
            justify-content: flex-end;
          ">
                    <v-btn small class="btndelete" @click.prevent="showComments = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>
                <v-col cols="12" md="12" style="">
                    <quill-editor v-model="medicalhistory.Comment" :options="quillOptions"></quill-editor>
                </v-col>
            </v-card>
        </v-dialog>

        <PrintMedicalHistory :dataProps="print"></PrintMedicalHistory>
    </div>
</template>

<script>
import Vue from "vue";
import Block from "@/components/Block";
import { DxDataGrid, DxColumn, DxExport } from "devextreme-vue/data-grid";
import DatePicker from "../../../components/DatePicker";
import Alerts from "@/components/Alerts";
import { mapState } from "vuex";
import { printToExcel } from "@/helpers/printToexcel";
import GeneralFilter from "@/components/GeneralFilter";
import UserProfile from "@/components/Displays/UserProfileDisplay.vue";
import UserProfileLab from "@/components/Displays/UserProfileDisplayLab.vue";
import { numberWithCommas } from "@/helpers/money";
import VeterinaryBillingPanel from "@/components/veterinary/VeterinaryBillingPanel.vue";
import PrintMedicalHistory from "../../../components/ReportsAndPrintings/PrintMedicalHistory.vue";
export default {
    name: "VeterinaryMedicalH",
    components: {
        VeterinaryBillingPanel,
        DxDataGrid,
        DxColumn,
        DatePicker,
        Block,
        Alerts,
        DxExport,
        GeneralFilter,
        UserProfile,
        UserProfileLab,
        PrintMedicalHistory,
    },
    props: {
        data: {
            type: Object,
            default: () => ({})
        },
        win: {
            type: Object,
            default: () => ({})
        },
        type: {
            type: String,
            default: ""
        },
        autosaveEnabled: {
            type: [Number, String, Boolean],
            default: 0
        }
    },
    data: () => ({
        alert: {
            type: "success",
            show: false,
            header: "",
            body: "",
        },
        customer: {},
        currency: JSON.parse(localStorage.getItem('branch')).Currency,
        itemQtyPattern: /^(0*[1-9][0-9]*(\.[0-9]+)?|0+\.[0-9]*[1-9][0-9]*)$/i,
        showBillPatient: false,
        useData: {},
        showServicesToAdd: false,
        showProductsToAdd: false,
        servicesToBill: [],
        productsToBill: [],
        servicesToAdd: [],
        productsToAdd: [],
        filterProducts: {
            filter: null
        },
        search: {
            filter: null
        },
        togglehide1: true,
        togglehide2: true,
        togglehide3: true,
        warehouses: [],
        selectedWarehouse: null,
        ID_Branch: JSON.parse(localStorage.getItem('branch')).ID_Branch,
        datatodelete: null,
        dialog: false,
        valid: false,
        url: null,
        showComments: false,
        date: null,
        patientinfo: [],
        weightunit: '',
        weight: '',
        medicalhistorys: {},
        medicalhistory: {
            Weight: "",
            vetExt: false,
            nameExt: "",
            height: "",
            pulse: "",
            temp: "",
            heartRate: "",
            breathRate: "",
            PhysicalHistorySummary: "",
            PresumptiveDiagnosis: "",
            FinalDiagnosis: "",
            Treatment: "",
            Comment: "",
        },
        loading: false,
        disabled1: 0,
        disabled2: 1,
        disabled3: 1,
        showFisicH: false,
        showDiagP: false,
        showDiagD: false,
        showTreat: false,
        showMedH: false,
        showRep: false,
        showSurg: false,
        showImg: false,
        vetExt: false,
        searchHistory: {},
        medicalaids: [],
        reproductions: [],
        surgerys: [],
        prescriptions: [],
        images: [],
        selectedvalues: true,
        tab: 1,
        showMedicalData: false,
        //useData: false,
        quillOptions: {
            modules: {
                toolbar: {
                    container: [
                        ['bold', 'underline', 'strike'],
                        ['blockquote'],
                        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                        [{ 'indent': '-1' }, { 'indent': '+1' }],
                        [{ 'align': [] }],
                        [{ 'color': [] }, { 'background': [] }],
                    ],
                    handlers: {},
                },
            },
            theme: "snow",
        },
        print: {
            show: false,
            data: [],
        },
        autosaveStatus: "idle",
        autosaveTimer: null,
        autosaveHideTimer: null,
        autosaveDelayMs: 1200,
        autosaveLastSavedFingerprint: "",
        autosaveInitialized: false,
        suppressAutosaveUpdates: true,
        autosaveInFlight: false,
        componentAutosaveEnabled: true
    }),

    computed: {
        ...mapState("rolesUser", {
            rolesStatus: (state) => state.roles,
        }),
        isAutosaveEnabled() {
            return this.autosaveEnabled === 1 || this.autosaveEnabled === "1" || this.autosaveEnabled === true;
        },
        isAutosaveActive() {
            return this.isAutosaveEnabled && this.componentAutosaveEnabled;
        },
        autosaveStatusLabel() {
            if (!this.isAutosaveActive) return "";
            if (!this.autosaveInitialized || this.suppressAutosaveUpdates || this.loading) return "";
            if (this.autosaveStatus === "saving") return "Guardando...";
            if (this.autosaveStatus === "saved") return "Guardado";
            if (this.autosaveStatus === "error") return "Error al guardar";
            return "";
        }
    },
    async mounted() {
        if (this.data) {
            Object.keys(this.data).map((el) => {
                Vue.set(this.patientinfo, el.toLowerCase(), this.data[el]);
            });
            this.medicalhistory.vetExt = false;
            this.medicalhistory.nameExt = '';
            this.medicalhistory.Weight = this.data.Weight;
            this.url = this.$store.getters.getBackendUrl + "/public" + this.data.ProfilePicPath;
            this.useData = JSON.parse(localStorage.getItem("user"));
            this.branchConfig = JSON.parse(localStorage.getItem("branch"));
            if(this.branchConfig?.weightunit) this.weightunit = this.branchConfig.weightunit;
            if(this.data?.weightunit) this.weightunit = this.data.weightunit;

            if(this.data.VeterinarioExterno == 1 || this.data.VeterinarioExterno == true) {
                this.medicalhistory.vetExt = true;
                this.medicalhistory.nameExt = this.data.NombreVeterinarioExterno;
                
            }
            else {
                this.medicalhistory.vetExt = false;
                this.medicalhistory.nameExt = '';
            }
            this.vetExt = this.medicalhistory.vetExt;

            console.log('mounted', this.data);
            this.customer.ID_Customer = this.data.ID_Customer;
            console.log('customer', this.customer);
            
            //this.useData = JSON.parse(localStorage.getItem("user"));
            this.warehouses = await this.$API.warehouse.getWarehousesFiltered({ isPatient: true });
            this.filterProducts.business = this.useData.businessid;
            this.filterProducts.branch = this.useData.branch;
            const found = this.warehouses.find((wh) => wh.Active == true && wh.ID_Branch == this.ID_Branch); 
            this.selectedWarehouse = found ? found.ID_Warehouse : (this.warehouses.length == 0 ? 0 : this.warehouses[0].ID_Warehouse);
            //this.selectedWarehouse = this.warehouses.length == 0 ? 0 : this.warehouses[0].ID_Warehouse;
            this.filterProducts.warehouse = this.selectedWarehouse;    
            await this.getServices();
            await this.getProducts();
            await this.getDefaultServices();
        }

        const localparams = JSON.parse(localStorage.getItem("localparams")) || null;
        if (localparams && localparams.weightunit) this.weightunit = localparams.weightunit;

        if(this.medicalhistory && this.medicalhistory.Weight.includes('Kg')) this.weightunit = 'Kg';
        if(this.medicalhistory && this.medicalhistory.Weight.includes('Lb')) this.weightunit = 'Lb';

        if(this.medicalhistory.Weight && this.medicalhistory.Weight.includes(this.weightunit)) {
            this.weight = this.medicalhistory.Weight.slice(0, -2).replace(' ', '');
        } else {
            this.weight = this.medicalhistory.Weight.replace(' ', '');
        }

        this.medicalhistory.ID_Patient = this.patientinfo.id_patient;
        this.searchHistory.patientId = this.patientinfo.id_patient;
        try {
            await this.loadHistoryMedical();
        } finally {
            this.finishAutosaveSetup();
        }
        //this.$store.dispatch("rolesUser/getAllRoles");
    },
    beforeDestroy() {
        this.clearAutosaveTimers();
    },
    watch: {
        date: {
            handler: function () {
                this.searchHistory.date = this.date;
                this.medicalaids = [];
                this.scheduleAutosave();
            },
            immediate: true,
        },
        medicalhistory: {
            deep: true,
            handler() {
                this.scheduleAutosave();
            }
        },
        weight() {
            this.scheduleAutosave();
        },
        weightunit() {
            this.scheduleAutosave();
        },
        componentAutosaveEnabled(value) {
            if (value) {
                this.autosaveLastSavedFingerprint = this.buildAutosaveFingerprint();
                return;
            }

            this.clearAutosaveTimers();
            this.setAutosaveStatus("idle");
        },
        servicesToAdd: {
            deep: true,
            immediate: true,
            handler(newVal) {
                this.showServicesToAdd = newVal.length !== 0;
                newVal.forEach(service => {
                if (service.Price !== undefined) {
                    service.UnitPrice = service.Price;
                }
                });
            }
        },
        productsToAdd: {
            deep: true,
            immediate: true,
            handler() {
                if(this.productsToAdd.length !== 0) {
                    this.showProductsToAdd = true;
                }
                else {
                    this.showProductsToAdd = false;
                }
            }
        },
    },
    methods: {
        createEmptyMedicalHistory() {
            return {
                Weight: this.data?.Weight || "",
                vetExt: false,
                nameExt: "",
                height: "",
                pulse: "",
                temp: "",
                heartRate: "",
                breathRate: "",
                PhysicalHistorySummary: "",
                PresumptiveDiagnosis: "",
                FinalDiagnosis: "",
                Treatment: "",
                Comment: "",
                ID_Patient: this.patientinfo.id_patient,
            };
        },
        finishAutosaveSetup() {
            this.$nextTick(() => {
                this.autosaveLastSavedFingerprint = this.buildAutosaveFingerprint();
                this.autosaveInitialized = true;
                this.suppressAutosaveUpdates = false;
                this.setAutosaveStatus("idle");
            });
        },
        clearAutosaveTimers() {
            if (this.autosaveTimer) {
                clearTimeout(this.autosaveTimer);
                this.autosaveTimer = null;
            }

            if (this.autosaveHideTimer) {
                clearTimeout(this.autosaveHideTimer);
                this.autosaveHideTimer = null;
            }
        },
        setAutosaveStatus(status) {
            if (this.autosaveHideTimer) {
                clearTimeout(this.autosaveHideTimer);
                this.autosaveHideTimer = null;
            }

            this.autosaveStatus = status;

            if (status === "error") {
                this.autosaveHideTimer = setTimeout(() => {
                    this.autosaveStatus = "idle";
                    this.autosaveHideTimer = null;
                }, 2000);
            }
        },
        buildAutosaveFingerprint() {
            return JSON.stringify({
                id: this.medicalhistory.ID_MH || null,
                date: this.date || "",
                weight: this.weight || "",
                weightunit: this.weightunit || "",
                height: this.medicalhistory.height || "",
                pulse: this.medicalhistory.pulse || "",
                temp: this.medicalhistory.temp || "",
                heartRate: this.medicalhistory.heartRate || "",
                breathRate: this.medicalhistory.breathRate || "",
                vetExt: !!this.medicalhistory.vetExt,
                nameExt: this.medicalhistory.nameExt || "",
                physicalHistorySummary: this.medicalhistory.PhysicalHistorySummary || "",
                presumptiveDiagnosis: this.medicalhistory.PresumptiveDiagnosis || "",
                finalDiagnosis: this.medicalhistory.FinalDiagnosis || "",
                treatment: this.medicalhistory.Treatment || "",
                comment: this.medicalhistory.Comment || ""
            });
        },
        hasAutosaveDataToPersist() {
            return [
                this.weight,
                this.medicalhistory.height,
                this.medicalhistory.pulse,
                this.medicalhistory.temp,
                this.medicalhistory.heartRate,
                this.medicalhistory.breathRate,
                this.medicalhistory.nameExt,
                this.medicalhistory.PhysicalHistorySummary,
                this.medicalhistory.PresumptiveDiagnosis,
                this.medicalhistory.FinalDiagnosis,
                this.medicalhistory.Treatment,
                this.medicalhistory.Comment
            ].some((value) => String(value || "").trim() !== "");
        },
        scheduleAutosave() {
            if (!this.isAutosaveActive || !this.autosaveInitialized || this.suppressAutosaveUpdates) return;

            if (!this.hasAutosaveDataToPersist()) {
                this.clearAutosaveTimers();
                this.setAutosaveStatus("idle");
                this.autosaveLastSavedFingerprint = this.buildAutosaveFingerprint();
                return;
            }

            if (this.autosaveTimer) {
                clearTimeout(this.autosaveTimer);
            }

            this.autosaveTimer = setTimeout(() => {
                this.autosaveTimer = null;
                this.performAutosave();
            }, this.autosaveDelayMs);
        },
        async performAutosave() {
            if (!this.isAutosaveActive || !this.autosaveInitialized || this.suppressAutosaveUpdates) return;

            const fingerprint = this.buildAutosaveFingerprint();
            if (!this.hasAutosaveDataToPersist() || fingerprint === this.autosaveLastSavedFingerprint) {
                this.setAutosaveStatus("saved");
                this.autosaveLastSavedFingerprint = fingerprint;
                return;
            }

            if (this.autosaveInFlight) {
                this.scheduleAutosave();
                return;
            }

            this.autosaveInFlight = true;
            this.setAutosaveStatus("saving");

            try {
                if (this.medicalhistory.ID_MH && !this.selectedvalues) {
                    await this.updateMedicalHistory({ silent: true, reloadAfter: false });
                } else {
                    await this.saveMedicalHistory({ silent: true, resetAfter: false, reloadAfter: true });
                }

                this.autosaveLastSavedFingerprint = this.buildAutosaveFingerprint();
                this.setAutosaveStatus("saved");
            } catch (error) {
                console.log("--------autosave error-----", error);
                this.setAutosaveStatus("error");
            } finally {
                this.autosaveInFlight = false;
                if (this.buildAutosaveFingerprint() !== this.autosaveLastSavedFingerprint) {
                    this.scheduleAutosave();
                }
            }
        },
        printMedicalHistory() {
            this.print = {
                show: true,
                data: {
                    medicalhistory: this.medicalhistory,
                    patientinfo: this.data,
                }
            }
        },
        totalXQuantity( { Price, quantity } ) {
            return `${this.currency}${ numberWithCommas( parseFloat( Price * quantity ).toFixed( 2 ) ) }`
        },
        async handleSelectWarehouse() {
            this.loading = true;
            this.filterProducts.warehouse = this.selectedWarehouse;
            await this.getProducts();
            this.$refs.werehouseRef.blur();
            this.loading = false;
        },
        addService(data) {
            const isRepetitive = this.servicesToAdd.find((service) => service.ID_Service === data.ID_Service);

            if (!isRepetitive) {
                this.servicesToAdd.push({ ...data, quantity: 1, UnitPrice: parseFloat(data.Price), unitPrice: `${this.currency}${numberWithCommas(parseFloat(data.Price).toFixed(4))}` });
            } else {
                const service = this.servicesToAdd.find(item => item.ID_Service === data.ID_Service)
                if(service) {
                    service.quantity++;
                }
                console.log("Service already exists in servicesToAdd");
            }
        },
        addProduct(data) {
            const isRepetitive = this.productsToAdd.find((item) => item.ID_Item === data.ID_Item);
            if (!isRepetitive) {
                this.productsToAdd.push({ ...data, quantity: 1, UnitPrice: parseFloat(data.ItemPrice), unitPrice: `${this.currency}${numberWithCommas(parseFloat(data.ItemPrice).toFixed(4))}` });
            } else {
                const product = this.productsToAdd.find((item) => item.ID_Item === data.ID_Item);
                if(product) {
                    product.quantity++;
                }
                console.log("Product already exists in productsToAdd.");
            }
        },
        deleteService(data) {
            const serviceIndex = this.servicesToAdd.findIndex((service) => service.CodeService === data.CodeService);

            if (serviceIndex !== -1) {
                this.servicesToAdd.splice(serviceIndex, 1);
            }
        },
        deleteProduct(data) {
            const index = this.productsToAdd.findIndex((item) => item.ID_Item === data.ID_Item);

            if (index !== -1) {
                this.productsToAdd.splice(index, 1);
            }
        },
        getServices() {
            this.$API.services.getAllServices(this.filterServices).then((response) => {
                this.servicesToBill = response;
            });
        },
        getProducts() {
            this.$API.products.getProductsToBillForInvoice(this.filterProducts).then((response) => {
                this.productsToBill = response;
            });
        },
        getDefaultServices() {
            this.$API.services.getDefaultServices().then((response) => {
                this.servicesDefault = response;
            });
        },
        servicesFilterHandler(response) {
            this.servicesToBill = response;
        },
        productsFilterHandler(response) {
            this.productsToBill = response;
        },
        getItemsToBeBilled() {
            this.$API.veterinarypatients.getServicesToBeBilled({ 'customer': this.data.ID_Customer })
            .then((response) => {
                this.servicesToAdd = []
                for(let i = 0; i < response.length; i++){
                this.servicesToAdd.push({ ...response[i], unitPrice: `${this.currency}${numberWithCommas(parseFloat(response[i].Price).toFixed(4))}` });
                }
            });
            this.$API.veterinarypatients.getProductsToBeBilled({ 'customer': this.data.ID_Customer }).then((res) => {
                if(res.success) {
                this.productsToAdd = [];
                for (const item of res.data) {
                    this.productsToAdd.push({ ...item, quantity: item.Quantity, unitPrice: `${this.currency}${numberWithCommas(parseFloat(item.ItemPrice).toFixed(4))}`});
                }
                }
            });
        },
        async saveItemsToBeBilled() {
            this.showBillPatient = false;
            this.loading = true;

            try {
                if(this.servicesToAdd.length) {
                await this.$API.veterinarypatients.saveServicesToBeBilled({ 'customer': this.customer.ID_Customer, 'services': this.servicesToAdd })
                .then((res) => {
                    console.log(res);
                })
                .catch((err) => {
                    console.log(err);
                    throw new Error('Ocurrio un error al guardar los servicios.');
                });
                }
                if(this.productsToAdd.length) {
                console.log(this.productsToAdd);
                
                await this.$API.veterinarypatients.saveProductsToBeBilled({ 'customer': this.customer.ID_Customer, 'products': this.productsToAdd })
                .then((res) => {
                    console.log(res);
                })
                .catch((err) => {
                    console.log(err);
                    throw new Error('Ocurrio un error al guardar los productos.');
                });
                }
                await this.getItemsToBeBilled();
                this.loading = false;
                this.showAlert("success", "Exito", "Los datos de facturación de este paciente han sido guardados.")
            } catch (error) {
                console.log(error);
                this.loading = false;
                this.showAlert("warning", "Advertencia", "Ha ocurrido un error, por favor intentarlo nuevamente.")
            }

        },
        async billedPatientsOfCustomer() {
            this.showBillPatient = false;
            this.loading = true;

            try{
                await this.$API.veterinarypatients.saveServicesToBeBilled({'customer': this.customer.ID_Customer, 'services': this.servicesToAdd});
                await this.$API.veterinarypatients.saveProductsToBeBilled({ 'customer': this.customer.ID_Customer, 'products': this.productsToAdd });
                let responseBill = await this.$API.veterinarypatients.billedPatientsOfCustomer({ 'customer': this.customer.ID_Customer});

                this.loading = false;

                if (responseBill?.status == false) {
                    this.showAlert("dangerHtml", "Advertencia", "No se puede crear el comprobante porque se encontraron los siguientes errores: <br/><br/>" + responseBill.message)  
                    return
                }

                this.showAlert("success", "Exito", `Se ha realizado la factura de los ${this.servicesToAdd.length && this.productsToAdd.length ? 'servicios y productos' : this.servicesToAdd.length ? 'servicios' : this.productsToAdd.length ? 'productos' : 'items' } seleccionados, podrá observarla en el módulo de POS en listo para facturar.`);
                await this.getItemsToBeBilled();        
            }
            catch(error) {
                console.log(error)
                this.loading = false
                this.showAlert("warning", "Advertencia", "Ha ocurrido un error, por favor intentarlo nuevamente.")
            }
        },

        onExporting(e) {
            printToExcel(e, "Historial Medico");
        },
        handlerVetExt() {
            this.vetExt = this.medicalhistory.vetExt;
        },
        checkhistoryDatetoday(date) {
            /*let datetoday = false;
            if(this.medicalhistorys.length) {
                this.medicalhistorys.forEach((el) => {
                    if (el.MedicalHistoryDate == date) {
                        this.showMedicalHistory(el);
                        datetoday = true;
                    }
                });
            }
            if (!datetoday) {
                //this.resetData();
                this.date = date;
            }*/
            this.date = date;
        },
        changeWeight(e) {
            this.medicalhistory.Weight = e.replace(' ', '');
            console.log('weigth', this.medicalhistory.Weight);
        },
        switchWeightUnit(e) {
            this.weightunit = e;
            console.log(this.weightunit);
        },
        syncMedicalHistoryForPersistence() {
            this.medicalhistory.MedicalHistoryDate = this.date;
            this.medicalhistory.ID_Patient = this.patientinfo.id_patient;

            if (this.medicalhistory.Weight) {
                if (!this.medicalhistory.Weight.includes('Lb') && !this.medicalhistory.Weight.includes('Kg')) {
                    this.medicalhistory.Weight = this.medicalhistory.Weight.concat(' ', this.weightunit);
                } else if (this.weightunit && !this.medicalhistory.Weight.includes(this.weightunit)) {
                    const newValue = this.medicalhistory.Weight.slice(0, -3);
                    this.medicalhistory.Weight = newValue.concat(' ', this.weightunit);
                }
            }

            this.medicalhistory.Talla = this.medicalhistory.height;
            this.medicalhistory.Pulso = this.medicalhistory.pulse;
            this.medicalhistory.FrecuenciaCardiaca = this.medicalhistory.heartRate;
            this.medicalhistory.FrecuenciaRespiratoria = this.medicalhistory.breathRate;
            this.medicalhistory.Temperatura = this.medicalhistory.temp;

            if (this.medicalhistory.vetExt) {
                this.medicalhistory.VeterinarioExterno = 1;
                this.medicalhistory.NombreVeterinarioExterno = this.medicalhistory.nameExt || '';
            } else {
                this.medicalhistory.VeterinarioExterno = 0;
                this.medicalhistory.NombreVeterinarioExterno = '';
            }
        },
        Preview_image() {
            this.url = URL.createObjectURL(this.image);
        },

        disabledOne() {
            this.disabled1 = (this.disabled1 + 1) % 2;
        },
        disabledTwo() {
            this.disabled2 = (this.disabled2 + 1) % 2;
        },
        disabledThree() {
            this.disabled3 = (this.disabled3 + 1) % 2;
        },

        showMedicalHistory(data) {
            this.suppressAutosaveUpdates = true;
            this.clearAutosaveTimers();
            this.setAutosaveStatus("idle");
            this.loading = true;
            this.medicalhistory.Weight = data.Weight;
            
            if(this.medicalhistory.Weight.includes('Kg')) {
                this.weightunit = 'Kg';
                this.weight = this.medicalhistory.Weight.slice(0, -2).replace(' ', '');
            }
            else if(this.medicalhistory.Weight.includes('Lb')) {
                this.weightunit = 'Lb';
                this.weight = this.medicalhistory.Weight.slice(0, -2).replace(' ', '');
            }
            else {
                this.weightunit = '';
                this.weight = this.medicalhistory.Weight.replace(' ', '');
            }

            if (data.FinalDiagnosis == "<p>undefined</p>") {
                data.FinalDiagnosis = "<p></p>";
            }
            if (data.PresumptiveDiagnosis == "<p>undefined</p>") {
                data.PresumptiveDiagnosis = "<p></p>";
            }
            if (data.Treatment == "<p>undefined</p>") {
                data.Treatment = "<p></p>";
            }

            this.medicalhistory = {
                ...this.createEmptyMedicalHistory(),
                ...data
            };
            this.date = this.medicalhistory.MedicalHistoryDate;

            this.medicalhistory.height = data.Talla || '';
            this.medicalhistory.pulse = data.Pulso || '';
            this.medicalhistory.temp = data.Temperatura || '';
            this.medicalhistory.heartRate = data.FrecuenciaCardiaca || '';
            this.medicalhistory.breathRate = data.FrecuenciaRespiratoria || '';
            if(data.VeterinarioExterno == 1 || data.VeterinarioExterno == true) {
                this.medicalhistory.vetExt = true;
                this.medicalhistory.nameExt = data.NombreVeterinarioExterno;
            }
            else {
                this.medicalhistory.vetExt = false;
                this.medicalhistory.nameExt = '';
            }
            this.vetExt = this.medicalhistory.vetExt;

            this.loading = false;
            this.selectedvalues = false;
            this.finishAutosaveSetup();
        },
        filterHandler(response) {
            console.log(response);
            this.medicalhistorys = response;
        },
        loadHistoryMedical() {
            this.loading = true;
            return this.$API.veterinarymedicalhistory
                .loadMedicalHistorySorted(this.searchHistory)
                .then((data) => {
                    this.medicalhistorys = data;

                    let datetoday = this.moment().format("DD/MM/YYYY");
                    data.forEach((element) => {
                        if (element.MedicalHistoryDate == datetoday) {
                            this.showMedicalHistory(element);
                            this.selectedvalues = false;
                        }
                    });
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                    throw new Error("load-history-error");
                });
        },

        saveMedicalHistory(options = {}) {
            const { silent = false, resetAfter = true, reloadAfter = true } = options;
            let datetoday = false;
            if (!silent) {
                this.loading = true;
            }

            if (this.medicalhistorys.length > 0) {
                for (const i in this.medicalhistorys) {
                    if (this.medicalhistorys[i].MedicalHistoryDate == this.date) {
                        if (!silent) {
                            this.showAlert(
                                "danger",
                                "error",
                                "Ya existe un registro para la fecha seleccionada"
                            );
                        }

                        datetoday = true;
                    }
                }
            }

            if (!datetoday) {
                this.syncMedicalHistoryForPersistence();
                this.medicalhistory.ID_User_Insert = JSON.parse(localStorage.getItem("user")).id;
                return this.$API.veterinarymedicalhistory
                    .saveMedicalHistory(this.medicalhistory)
                    .then(() => {
                        if (!silent) {
                            this.showAlert("success", "Exito", "Se guardo el registro correctamente");
                        }
                        if (resetAfter) {
                            this.resetData();
                        }
                        if (reloadAfter) {
                            return this.loadHistoryMedical();
                        }
                        return null;
                    })
                    .catch((data) => {
                        if (!silent) {
                            this.showAlert("danger", "Error", data.message);
                        }
                        throw data;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            } else {
                this.loading = false;
                return Promise.reject(new Error("duplicate-medical-history-date"));
            }
        },

        updateMedicalHistory(options = {}) {
            const { silent = false, reloadAfter = true } = options;
            if (!silent) {
                this.loading = true;
            }
            this.medicalhistory.ID_User_Update = JSON.parse(localStorage.getItem("user")).id;
            this.syncMedicalHistoryForPersistence();

            return this.$API.veterinarymedicalhistory
                .updateMedicalHistory(this.medicalhistory)
                .then(() => {
                    if (!silent) {
                        this.showAlert("success", "Exito", "Se actualizo el registro correctamente");
                    }
                    if (reloadAfter) {
                        return this.loadHistoryMedical();
                    }
                    return null;
                })
                .catch((data) => {
                    console.log(data);
                    if (!silent) {
                        this.showAlert(
                            "danger",
                            "Error",
                            "Ocurrio un error, por favor contacte al administrador."
                        );
                    }
                    throw data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        deleteMedicalHistory(data) {
            this.loading = true;
            this.$API.veterinarymedicalhistory
                .deleteMedicalHistory(data)
                .then(() => {
                    this.loading = true;
                    this.showAlert("success", "Exito", "Se elimino el registro correctamente");
                    this.resetData();
                    this.loadHistoryMedical();
                })
                .catch((data) => {
                    this.showAlert("danger", "Error", data.message);
                    this.loading = false;
                });
        },

        resetData() {
            this.suppressAutosaveUpdates = true;
            this.clearAutosaveTimers();
            this.setAutosaveStatus("idle");
            this.medicalhistory = this.createEmptyMedicalHistory();
            this.vetExt = false;
            
            if(this.branchConfig?.weightunit) this.weightunit = this.branchConfig.weightunit;
            if(this.data?.weightunit) this.weightunit = this.data.weightunit;

            const localparams = JSON.parse(localStorage.getItem("localparams")) || null;
            if (localparams && localparams.weightunit) this.weightunit = localparams.weightunit;

            if(this.medicalhistory && this.medicalhistory.Weight.includes('Kg')) this.weightunit = 'Kg';
            if(this.medicalhistory && this.medicalhistory.Weight.includes('Lb')) this.weightunit = 'Lb';

            if(this.medicalhistory.Weight && this.medicalhistory.Weight.includes(this.weightunit)) {
                this.weight = this.medicalhistory.Weight.slice(0, -2).replace(' ', '');
            } else {
                this.weight = this.medicalhistory.Weight.replace(' ', '');
            }
            
            this.date = this.moment().format("DD/MM/YYYY");
            this.selectedvalues = true;
            this.finishAutosaveSetup();
        },
        closeAlert() {
            this.alert.show = false;
            if (this.alert.options == "deletedate") {
                this.datatodelete = null;
            }
        },
        acceptAlert() {
            this.alert.show = false;

            if (this.alert.options == "deletedate") {
                this.deleteMedicalHistory(this.datatodelete);
            }
        },
        showAlert(type, header, body, options = null) {
            type = type == null ? "danger" : type;
            this.alert.type = type;
            this.alert.header = header;
            this.alert.body = body;
            this.alert.show = true;
            this.alert.options = options != null ? options : null;
        },
        confirmdelete(data) {
            this.showAlert(
                "question",
                "Eliminar",
                "¿Está seguro que desea eliminar el registro?",
                "deletedate"
            );
            this.datatodelete = data;
        },

        onEditorChange() { },

        /*onEditorChange(e) {
                    //this.medicalhistory.comment = e.html;
                },*/
    },
};
</script>

<style scoped>
.btndisable {
    background-color: #41464c !important;
    color: white;
}
.btndisable2 {
    background-color: #1976d2 !important;
    color: white;
}

.tabsB {
    width: 100%;
    padding: 10px;
    background-color: #1976d2;
    color: white;
    border-radius: 15px;
    border-style: solid;
    border-color: black;
    border-width: 1px;
}

.tabsB:hover {
    cursor: pointer;
}

.tabs:hover {
    background-color: rgba(80, 80, 80, 1);
    cursor: pointer;
}

.btnblue {
    background-color: #1976d2 !important;
    color: white;
}

.btnclean {
    background-color: #f29d35 !important;
    color: white;
}

.btnsave {
    background-color: #00a178 !important;
    color: white;
}

.tabs {
    width: 100%;
    padding: 10px;
    background-color: rgba(60, 60, 60, 1);
    color: white;
}

.text-white {
    color: white !important;
}

.box {
    border-style: solid;
    border-color: black;
    border-width: 1px;
    background-color: white;

    border-radius: 15px;
}

.label-forms {
    border-radius: 15px;
}

.tabs {
    padding: 10px;
    background-color: rgba(60, 60, 60, 1);
    color: white;
}

.btnblack {
    background-color: rgba(60, 60, 60, 1) !important;
    color: white !important;
}

.tabsNh {
    width: 100%;
    padding: 10px;
    background-color: rgba(60, 60, 60, 1);
    color: white !important;
    border-style: solid;
    border-color: black;
    border-width: 1px;
    border-radius: 10px;
}

.infopatient {
    margin-top: 5%;
}

.medical-history-actions-left {
    width: 158px;
    display: flex;
    align-items: center;
    min-height: 36px;
}

.autosave-toggle {
    margin-left: 0 !important;
}

.autosave-toggle ::v-deep .v-label {
    color: white !important;
    font-size: 0.9rem;
}

.autosave-toggle ::v-deep .v-input--selection-controls__input {
    margin-right: 6px;
}

.autosave-status {
    display: inline-flex;
    align-items: center;
    min-height: 32px;
    padding: 0 14px;
    border-radius: 8px;
    background-color: #00a178;
    color: white;
    font-size: 0.875rem;
    font-weight: 600;
    white-space: nowrap;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.18);
}

.autosave-status--saving {
    background-color: #00a178;
    color: white;
}

.autosave-status--saved {
    background-color: #00a178;
    color: white;
}

.autosave-status--error {
    background-color: #ffffff;
    color: #b42318;
}
</style>
